import styled from "@emotion/styled";

export const FormRoot = styled.form({
  height: "100%",
  position: "relative",
});
